// Tracks whether we've ever observed an authenticated session in this app
// instance. Set true when /auth/me resolves successfully, false on logout.
//
// Used by the axios 401 handler on native: on the very first /auth/me failure
// at cold start we want the MobileWelcome screen to handle login (no modal
// popping over a blank screen), but a 401 *after* we had a session (e.g.
// session expired mid-use) should still pop the modal.

let hasSession = false;

export function setHasSession(v: boolean): void {
  hasSession = v;
}

export function getHasSession(): boolean {
  return hasSession;
}
